export default [
	{  // 商品推荐
		path: 'recommended_list',
		name: 'm_recommended',
		component: () => import('@/pages/operation/recommended_list')
	}, {  // 商品推荐新增页
		path: 'recommended_add',
		name: 'recommended_add',
		meta: {
			title: '新增策略'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/recommended_add')
	}, {  // 商品推荐编辑页
		path: 'recommended_edit/:id',
		name: 'recommended_edit',
		meta: {
			title: '编辑策略'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/recommended_edit')
	}, {  // 热门关键字
		path: 'popular_key_words',
		name: 'm_product_popular_key_words',
		component: () => import('@/pages/operation/popular_key_words')
	}, {  // 常见问题
		path: 'problem_list',
		name: 'm_problem',
		component: () => import('@/pages/operation/problem_list')
	},{  // 文摘咨询
		path: 'abstract_consultation',
		name: 'm_abstract_consultation',
		component: () => import('@/pages/operation/abstract_consultation')
	}, {  // 文摘咨询新增页
		path: 'abstract_consultation_add',
		name: 'abstract_consultation_add',
		meta: {
			title: '新增资讯'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/abstract_consultation_add')
	}, {  // 文摘咨询编辑页
		path: 'abstract_consultation_edit/:id',
		name: 'abstract_consultation_edit',
		meta: {
			title: '编辑资讯'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/abstract_consultation_edit')
	}, {  // 素材库
		path: 'media/catalog/list',
		name: 'm_media_catalog',
		component: () => import('@/pages/operation/media_catalog_list')
	}, {  // 素材库-新增页
		path: 'media/catalog/add',
		name: 'media_catalog_add',
		meta: {
			title: '新增素材'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/media_catalog_add')
	}, {  // 素材库-编辑页
		path: 'media/catalog/edit/:id',
		name: 'media_catalog_edit',
		meta: {
			title: '编辑素材'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/media_catalog_edit')
	}, {  // 资源库
		path: 'media/resource/list',
		name: 'm_media_resource',
		component: () => import('@/pages/operation/media_resource_list')
	}
];